import {useState, useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {Modal, Button, InputGroup, FormControl, Row, Col} from 'react-bootstrap'
import {ReactComponent as IconHamburger} from 'img/icon/hamburger.svg'
import './KeyMenu.sass'
import actions from 'redux/actionsAndReducers/apiAccess_Actions.js'
import { push } from 'connected-react-router'
import url from 'tool/url.js'

const KeyMenu = (props) => {
    //#region Component mount
    const [mounted, setMounted] = useState(true)
    useEffect(() => {
        return function cleanup() {
            setMounted(false)
        }
    }, [])
    //#endregion Component mount

    const [show, setShow] = useState(false)

    const reduxDispatch = useDispatch()
    const reduxApiAccess = useSelector(store => store.apiAccess)
    const apiAccess = reduxApiAccess.value


    const hideModal = () => setShow(false)
    const showModal = () => {
        setShow(true)
    }
    const [newKey, _setNewKey] = useState('')
    const setNewKey = (value) => {
        if(value === undefined) _setNewKey('')
        _setNewKey(value)
    }

    const [responseStatus, setResponseStatus] = useState(undefined)

    //#region Auth fetch
    const authenticateKey = () => {
        const settings = {
            method: 'GET',
            credentials: process.env.NODE_ENV === 'production' ? "same-origin" : "include"
        }
        fetch(url(`/auth?key=${newKey}`), settings)
        .then(res=>{
            if(!mounted) return null
            if(res.status === 200){
                if(process.env.NODE_ENV === 'development') console.log('200: Received auth cookie')
                setResponseStatus(res.status)
            }
        })
        .then(()=>{
            reduxDispatch(actions.readApiAccess())
            setNewKey('')
        })
        .catch(err=>{
            if(process.env.NODE_ENV === 'development') console.log(err)
            
            setResponseStatus(err)
        })
    }
    //#endregion

    const inputGroup = <>
        <div id="key_menu" className="pb-4 px-3" style={{textAlign: 'center'}}>
            <InputGroup className="mb-1">
                <InputGroup.Prepend>
                    <InputGroup.Text id="inputGroup-sizing-default">Key</InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                    id="input"
                    aria-label="Key"
                    placeholder="XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX"
                    aria-describedby="inputGroup-sizing-default"
                    value={newKey}
                    onChange={(e)=>setNewKey(e.currentTarget.value)}
                    onKeyDown={(e)=>{ if(e.key==='Enter') authenticateKey()}}
                    />
                <Status value={responseStatus} />
            </InputGroup>
            <div className="d-flex justify-content-center">
                <Button variant="primary" onClick={authenticateKey} style={{minWidth: 200}}>Add</Button>
            </div>
        </div>
        <div className="mt-3 mx-5" style={{textAlign: 'center'}}>
            <label htmlFor="basic-url">{apiAccess.length} document{apiAccess.length>1?'s':''}</label>
            {apiAccess.length === 0
                ?<p htmlFor="basic-url" style={{fontStyle: 'italic'}}>Please add keys to gain access.</p>
                :null}
            <ApiAccessList data={apiAccess} onDelete={(name)=>reduxDispatch(actions.removeApiAccess(name))} hideDeleteBtn={props.hideDeleteBtn}/>
        </div>
    </>

    const modal = (body = null) => <>
        <IconHamburger onClick={showModal} className="cursor-pointer" style={{padding: 10, height: 45, width: 45}}/>
        
        <Modal show={show} onHide={hideModal}>
            <Modal.Header closeButton>
                <Modal.Title>Settings</Modal.Title>
            </Modal.Header>
            <Modal.Body className="pb-0">
            <label htmlFor="basic-url">Add documentation key</label>
            {inputGroup}
            
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-center mt-5">
                <Button variant="secondary" onClick={hideModal} style={{minWidth: 200}}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    </>

    if(props.mode === 'input') return inputGroup
    else return modal(inputGroup)
}
export default KeyMenu

const Status = (props) => {
    if(typeof props.responseStatus === 'number' && props.responseStatus >=400){
        return <span style={{color: 'var(--danger)'}}>{`${props.responseStatus} Unable to authenticate key.`}</span>
    }
    if(props.responseStatus instanceof Error || typeof props.responseStatus === 'number'){
        return <span style={{color: 'var(--danger)'}}>{`Unable to connect to server`}</span>
    }
    return null
}

const ApiAccessList = (props) => {
    if(Array.isArray(props.data)){
        const _data = props.data.filter(o=>o!==null)
        return _data.map((d, i)=><ApiAccess key={i} name={d.name} scope={d.scope} onDelete={props.onDelete} hideDeleteBtn={props.hideDeleteBtn}/>)
    }

    return null
}
ApiAccessList.defaultProps={
    name: undefined,
    scope: undefined,
    onDelete: undefined // Callback
}   

const ApiAccess =(props)=>{
    const _reduxDispatch = useDispatch()

    if(typeof props.name !== 'string' || props.scope === undefined || typeof props.onDelete !== 'function') return null
    const badgeStyle ={color: 'var(--white)', padding: '0px 10px', whiteSpace: 'nowrap', minHeight: 37}
    
    return(
        <Row className="py-2 api_access" style={{borderTop: 'solid thin var(--gray)'}}>
            <Col className="d-flex justify-content-center">
                <button 
                    className="btn btn-dark w-100"
                    style={badgeStyle} 
                    onClick={()=>_reduxDispatch(push(`/${props.name.toLowerCase()}`))}
                >
                    {`${props.name.toUpperCase()} - Scope ${props.scope}`}
                </button>
            </Col>
            {
                props.hideDeleteBtn ? null : 
                    <Col xs="auto" className="d-flex justify-content-start">
                        <button className="btn btn-danger" onClick={()=>props.onDelete(props.name)}>Forget</button>
                    </Col>
            }
        </Row>
    )
}
ApiAccess.defaultProps={
    name: undefined,
    scope: undefined,
    onDelete: undefined // Callback
}